module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginBg",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "loginHeader"
  }, [_c('el-row', {
    staticStyle: {
      "padding-top": "20px",
      "margin-left": "10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/logoLogin.png")
    },
    on: {
      "click": _vm.openLicenseDialog
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logoTxt"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('lin_global.logoTitle')) + "\n        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-box"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm loginform",
    attrs: {
      "id": "form-box",
      "model": _vm.loginForm,
      "rules": _vm.loginRules
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.yhdl')))]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "lang"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "placeholder": "",
      "readonly": ""
    },
    model: {
      value: (_vm.langName),
      callback: function($$v) {
        _vm.langName = $$v
      },
      expression: "langName"
    }
  }, [_c('el-dropdown', {
    attrs: {
      "slot": "append",
      "trigger": "click",
      "placement": "bottom-end"
    },
    on: {
      "command": _vm.langchange
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticStyle: {
      "width": "24px",
      "height": "16px",
      "margin-top": "5px"
    },
    attrs: {
      "src": _vm.langUrl
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.langs), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "command": item.value
      }
    }, [_c('img', {
      staticStyle: {
        "width": "24px"
      },
      attrs: {
        "src": item.url
      }
    }), _vm._v("  " + _vm._s(item.label))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    staticClass: "loginInput",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": _vm.$t('lin_global.zh')
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: "loginInput",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('lin_global.password')
    },
    on: {
      "change": _vm.pswChange
    },
    model: {
      value: (_vm.loginForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "checkPass", $$v)
      },
      expression: "loginForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "code"
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "loginInput",
    attrs: {
      "auto-complete": "off",
      "placeholder": _vm.$t('app_ckcode')
    },
    model: {
      value: (_vm.loginForm.code),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "code", $$v)
      },
      expression: "loginForm.code"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "width": "110px",
      "height": "40px"
    },
    attrs: {
      "src": _vm.codeObj ? _vm.codeObj.code : ''
    },
    on: {
      "click": _vm.recode
    }
  })])], 1)], 1), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin": "30px 0px 20px 10%",
      "color": "#979797"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jzmm')))]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "background-image": "linear-gradient(-90deg, #158EE9 0%, #2CACFD 100%)",
      "border-radius": "2px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.login')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('lin_global.bah')) + "\n    "), _c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "top-start",
      "title": _vm.$t('app_verUdCt'),
      "width": "200",
      "trigger": "hover"
    }
  }, [_c('div', {
    attrs: {
      "id": "markdownBody"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.verTip)
    }
  })]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    staticStyle: {
      "border": "none",
      "background": "none",
      "color": "#979797"
    }
  }, [_vm._v("v" + _vm._s(_vm.version))]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logining),
      expression: "logining"
    }],
    attrs: {
      "cclass": "gDia",
      "title": "Activate TMS",
      "size": "small"
    },
    on: {
      "close": _vm.closeDia
    },
    model: {
      value: (_vm.isauth),
      callback: function($$v) {
        _vm.isauth = $$v
      },
      expression: "isauth"
    }
  }, [_c('el-form', {
    ref: "aform",
    attrs: {
      "model": _vm.aform,
      "rrules": "rules2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "TMS is active until:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.aform.date))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n              Please contact the administrator to request a new activation code\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "userName",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.aform.usr),
      callback: function($$v) {
        _vm.$set(_vm.aform, "usr", $$v)
      },
      expression: "aform.usr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "password",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.authPswChange
    },
    model: {
      value: (_vm.aform.psw),
      callback: function($$v) {
        _vm.$set(_vm.aform, "psw", $$v)
      },
      expression: "aform.psw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "code",
      "label-width": _vm.formLabelWidth,
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.aform.code),
      callback: function($$v) {
        _vm.$set(_vm.aform, "code", $$v)
      },
      expression: "aform.code"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDia
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('aform')
      }
    }
  }, [_vm._v("Activate")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logining),
      expression: "logining"
    }],
    attrs: {
      "cclass": "gDia",
      "ttitle": "$t('app_mulfcau')",
      "size": "small"
    },
    on: {
      "close": _vm.closeDiaCk
    },
    model: {
      value: (_vm.ischeck),
      callback: function($$v) {
        _vm.ischeck = $$v
      },
      expression: "ischeck"
    }
  }, [_c('div', {
    attrs: {
      "id": "mfauthfr"
    }
  }, [_c('i', {
    staticClass: "fa fa-shield "
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('app_mulfcau')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_opmfackip6dycode')
    },
    model: {
      value: (_vm.code6),
      callback: function($$v) {
        _vm.code6 = $$v
      },
      expression: "code6"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('app_cantprvmcodectadm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.codeCheck
    }
  }, [_vm._v(_vm._s(_vm.$t('app_verifc')))])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Enter License",
      "visible": _vm.licenseDialogVisible,
      "close-on-click-modal": false,
      "show-close": false,
      "width": "400px"
    },
    on: {
      "update:visible": function($event) {
        _vm.licenseDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "licenseForm",
    attrs: {
      "model": _vm.licenseForm,
      "rules": _vm.licenseRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "MAC Address"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "readonly": "",
      "placeholder": "MAC Address will appear here"
    },
    model: {
      value: (_vm.macAddress),
      callback: function($$v) {
        _vm.macAddress = $$v
      },
      expression: "macAddress"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchMacAddress
    }
  }, [_vm._v("Get MAC Address")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "License Key",
      "prop": "licenseKey"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autocomplete": "off",
      "placeholder": "Enter your license key"
    },
    model: {
      value: (_vm.licenseForm.licenseKey),
      callback: function($$v) {
        _vm.$set(_vm.licenseForm, "licenseKey", $$v)
      },
      expression: "licenseForm.licenseKey"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.activationLicense
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bbf813a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 1052
// module chunks = 0